module.exports = __webpack_public_path__ + "img/0a543d3.jpg";